import React from 'react';
import PropTypes from 'prop-types';
import { CallupHead } from '@ifeng-fe/three_terminal/es/mobile/callupHead/index';
import errorBoundary from '@ifeng-fe/errorBoundary';

class Header extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        keyword: PropTypes.array,
        subid: PropTypes.string,
        wxLaunch: PropTypes.object,
    };

    clickHandle = () => {
        try {
            if (window.BJ_REPORT) {
                window.BJ_REPORT.report(new Error(), false, 51);
            }
        } catch (err) {
            console.error(err);
        }

        // 判断是否是安卓环境
        if (!navigator.userAgent.toLocaleLowerCase().includes('android')) {
            let secondNum = 0;
            const headTimer = setInterval(() => {
                if (secondNum > 3) {
                    clearInterval(headTimer);
                }
                if (window.pageIshareHidden) {
                    clearInterval(headTimer);
                    try {
                        if (window.BJ_REPORT) {
                            window.BJ_REPORT.report(new Error(), false, 52);
                        }
                    } catch (err) {
                        console.error(err);
                    }
                }

                secondNum++;
            }, 1000);
        }
    };

    render() {
        const { content, keyword, subid, wxLaunch } = this.props;
        const subidVal = subid ? `&subid=${subid}` : '';
        const downloads = content.isVideoShare
            ? {}
            : {
                  download: 'http://a.app.qq.com/o/simple.jsp?pkgname=com.ifeng.news2&ckey=CK1354725251042',
                  downloadAd: 'https://statistics.appstore.ifeng.com/index.php/api/godownload?app_id=4&d_ch=7641',
              };
        let callAppType = content.type === 'article' ? 'doc' : content.type;

        callAppType = callAppType === 'slide' ? 'immersionslide' : callAppType;
        const headData = {
            isVideoShare: content.isVideoShare,
            pageInfo: {
                type: callAppType,
                url: typeof window === 'object' ? location.href : '',
                id: content._id,
                downloads,
            },
            topClickInfo: {
                behavior: 'action',
                type: 'upopen',
                ref: `ucms_${content.base62Id}`,
                kind: 'article',
                callupKind: 'share52201',
            },
            fixClickInfo: {
                behavior: 'action',
                type: 'grgxfc',
                ref: `ucms_${content.base62Id}`,
                kind: 'article',
                callupKind: 'share52201',
            },
            hotKeyword: keyword,
            wxLaunchType: wxLaunch.wxLaunchType,
            wxLaunchSwitch: wxLaunch.wxLaunchSwitch,
            sendSucessLog: true,
        };

        return (
            <div onClick={this.clickHandle}>
                <CallupHead content={headData} />
            </div>
        );
    }
}

export default errorBoundary(Header);
